import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export function Environment() {
  const {
    t
  } = useLanguage();
  return <section id="entorno" className="py-24 bg-primary text-white overflow-hidden relative" data-id="element-152" data-mp="ueqdn63f5zrd">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-153" data-mp="13dbv0xx5n8qk">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-154" data-mp="13bhhi4o7qiwi">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="order-2 lg:order-1" data-id="element-155" data-mp="6ow1yruu6h8p">
            <div className="aspect-[4/5] rounded-2xl overflow-hidden shadow-2xl" data-id="element-156" data-mp="3k1g0w0og30ec">
              <img src="https://cdn.magicpatterns.com/uploads/k8qttzYiFqznYRx6zr86XZ/Dina_huapi.webp" alt={t('Vista aérea de Dina Huapi sobre la costa del lago Nahuel Huapi', 'Aerial view of Dina Huapi on the shore of Lake Nahuel Huapi')} className="w-full h-full object-cover" data-id="element-157" data-mp="3o2rgrehio79c" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="order-1 lg:order-2" data-id="element-158" data-mp="lrdn1ltevh1k">
            <span className="text-accent-light font-medium tracking-wider uppercase text-sm mb-3 block" data-id="element-159" data-mp="2v49czmf8si3">
              {t('El Entorno', 'The Surroundings')}
            </span>
            <h2 className="text-3xl md:text-4xl font-serif text-white mb-6" data-id="element-160" data-mp="1x7c2q8j3h1br">
              {t('Lago, montaña y tranquilidad', 'Lake, mountain, and tranquility')}
            </h2>
            <div className="space-y-6 text-white/80 text-lg font-light leading-relaxed" data-id="element-161" data-mp="a6739ctsq7k">
              <p data-id="element-162" data-mp="3hmqms9h09wnf">
                {t('Las cabañas están en una zona tranquila de Dina Huapi, a pasos del lago Nahuel Huapi y rodeadas de naturaleza. Un lugar para despertar con el canto de los pájaros, tomar mate al aire libre y dejar que el ritmo de la Patagonia te baje las revoluciones.', 'The cabins are in a quiet area of Dina Huapi, steps from Lake Nahuel Huapi and surrounded by nature. A place to wake up to the song of birds, drink mate outdoors, and let the rhythm of Patagonia slow you down.')}
              </p>
              <p data-id="element-163" data-mp="2oymf5ievj9i3">
                {t('Estás a pocos minutos de Bariloche, su Centro Cívico, los lagos y los circuitos clásicos — y con comercios y la parada de colectivo bien cerca.', 'You are a few minutes from Bariloche, its Civic Center, the lakes, and classic circuits — and with shops and the bus stop very close.')}
              </p>
              <p className="font-medium text-white" data-id="element-164" data-mp="1l1sdhpjcv0i4">
                {t('Lo mejor de los dos mundos: naturaleza y cercanía.', 'The best of both worlds: nature and proximity.')}
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}